import Switch from '@mui/material/Switch'
import { Avatar, Box, Button, Chip, Link, Typography } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import { showDangerToast, showToast } from '../../constants/toaster'
import NoDataImg from '../../../assets/img/no-data.gif'
import { useSelector } from 'react-redux'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { v4 as uuidv4 } from 'uuid'
import Utils from '../../constants/Utils'
import { useNavigate } from 'react-router-dom'

const label = { inputProps: { 'aria-label': 'Active status' } }

const getUserProfileId = (row) => {
  const candidates = [row?.profileLink, row?.userProfileId, row?.profileId, row?.link, row?.userId]
  return candidates.find((id) => id != null && id !== '') ?? null
}

export const ProfileAbuseTable = ({
  setShowAbuseReportDetails,
  datalist,
  setCallAPi,
  pagerecord,
  activePermission = true
}) => {
  const { formatDate } = Utils()
  const navigate = useNavigate()
  const userData = useSelector((state) => state?.userData)

  const goToUserManager = (row) => {
    const profileId = getUserProfileId(row)
    if (profileId != null) {
      navigate(`/user-manager/${profileId}`)
    }
  }

  const handleStatusChange = async (val) => {
    try {
      const path = `${urls.activeInActiveReport}?video=false&id=${val?.typeId}`
      const res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        showToast(response?.message)
        setCallAPi(uuidv4())
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  }

  if (!datalist?.length) {
    return (
      <Box className='text-center' py={5}>
        <img width='22%' src={NoDataImg} alt='No data' style={{ maxWidth: 140 }} />
        <Typography fontWeight={700} sx={{ mt: 2 }}>
          No profile reports found
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Try adjusting filters or date range
        </Typography>
      </Box>
    )
  }

  const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize

  return (
    <Box>
      <Box display='flex' alignItems='center' gap={1} mb={2}>
        <PersonIcon color='primary' fontSize='small' />
        <Typography variant='subtitle2' fontWeight={700} color='text.secondary'>
          PROFILE REPORTS
        </Typography>
      </Box>
      <div className='table-responsive'>
        <table className='table align-items-center table-flush'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>#</th>
              <th scope='col'>User</th>
              <th scope='col'>User ID</th>
              <th scope='col'>Profile</th>
              <th scope='col'>Reports</th>
              <th scope='col'>Last report</th>
              <th scope='col'>Active</th>
              <th scope='col'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {datalist.map((val, ind) => {
              const profileId = getUserProfileId(val)
              return (
              <tr key={val?.typeId || val?.userId || ind}>
                <td>{startIndex + ind + 1}</td>
                <td>
                  {profileId ? (
                    <Link
                      component='button'
                      variant='body1'
                      underline='hover'
                      fontWeight={600}
                      onClick={() => goToUserManager(val)}
                    >
                      {val?.userName || '—'}
                    </Link>
                  ) : (
                    <Typography fontWeight={600}>{val?.userName || '—'}</Typography>
                  )}
                </td>
                <td>
                  <Typography variant='body2' sx={{ wordBreak: 'break-all' }}>
                    {val?.userId || '—'}
                  </Typography>
                </td>
                <td>
                  <Box display='flex' alignItems='center' gap={1.5}>
                    <Avatar
                      src={val?.profilePictureUrl}
                      alt={val?.userName}
                      sx={{ width: 48, height: 48 }}
                    >
                      {(val?.userName || '?')[0]}
                    </Avatar>
                    {profileId ? (
                      <Button
                        size='small'
                        variant='text'
                        onClick={() => goToUserManager(val)}
                      >
                        View profile
                      </Button>
                    ) : null}
                  </Box>
                </td>
                <td>
                  <Chip label={val?.reportCount ?? 0} color='error' size='small' variant='outlined' />
                </td>
                <td>{formatDate(val?.updatedAt)}</td>
                <td>
                  <Switch
                    {...label}
                    checked={!!val?.active}
                    disabled={!activePermission}
                    onChange={() => {
                      if (activePermission) handleStatusChange(val)
                    }}
                    size='small'
                  />
                </td>
                <td>
                  <Button
                    size='small'
                    variant='outlined'
                    onClick={() => setShowAbuseReportDetails({ ...val, reportKind: 'PROFILE' })}
                  >
                    View reports
                  </Button>
                </td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
    </Box>
  )
}
